import { theme as baseTheme, extendTheme } from '@eigtech/ui-shared-dave'

type Dict<T = unknown> = Record<string, T>

export const theme: Dict = extendTheme(baseTheme, {
  components: {
    Drawer: {
      sizes: {
        nav: {
          dialog: { maxW: 64 },
        },
      },
    },
  },
})
